<template>
    <div class="aside-dropdown grid" :class="[bemFacet]">
        <component v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                :is="plugin.type"
                :position="pluginIdx"
                :plugin="plugin">
        </component>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import cmsPlaceholder from 'vue/mixins/cms/cms-placeholder';


    export default {
        mixins: [
            cmsPlaceholder,
            bemMixin('aside-dropdown'),
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?4092654c